import React from 'react'
import PropTypes from 'prop-types'
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from './ReactEcharts';

var replaceReg = /([&<>"'])/g;
var replaceMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;'
};

function encodeHTML(source) {
  return source == null
  ? ''
  : (source + '').replace(replaceReg, function (str, c) {
    return replaceMap[c];
  });
}

class SankeyDiagram extends React.Component {
  constructor(props) {
    super(props)
    this.lineStyle = {
      normal: {
        //color: 'source',
        color: '#000',
        opacity: 0.3,
      }
    };
    this.itemStyle = {
      normal: {
      },
      emphasis: {
        barBorderWidth: 1,
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: 'rgba(0,0,0,0.8)'
      }
    };

    this.state = this.getInitialState();
  }
  getInitialState = () => ({option: this.getOption()});

  componentWillReceiveProps(nextProps) {
    if (nextProps.data === this.props.data)
      return;
    this.updateChart(nextProps)
  }

  getOption = () => ({
    color: ['#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9',
      '#bc80bd', '#ccebc5', '#8dd3c7', '#ffffbc', '#bebada', '#ffed6f'],
    tooltip : {
      position: 'top',
    },
    series: []
  });

  updateChart = (props) => {
    let {data, links, sizeFactor} = props;
    const option = cloneDeep(this.state.option); // immutable

    option.series = {
      type: 'sankey',
      layout:'none',
      focusNodeAdjacency: 'allEdges',
      itemStyle: this.itemStyle,
      lineStyle: this.lineStyle,
      data: data,
      links: links,
      label: {
        position: 'top',
        fontSize: 12 * sizeFactor,
        //textBorderColor: '#FFF',
        //textBorderWidth: sizeFactor,
      },
      nodeGap: 22,
      left: '15%',
      right: '15%',
    };

    this.setState({
      option,
    });
  };

  onChartClick(params) {
    if(params.componentType !== 'series')
      return;
    if(this.props.onSelected)
      this.props.onSelected(params.dataIndex)
  }

  render() {
    let onEvents = {
      'click': this.onChartClick.bind(this),
    }
    return (
      <ReactEcharts ref='echarts_react'
        option={this.state.option}
        style={{width: this.props.width, height: this.props.height}}
        onEvents={onEvents}
      />
    )
  }
}
 
SankeyDiagram.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onSelected: PropTypes.func,
}

export default SankeyDiagram
